export var Actions;
(function (Actions) {
    Actions["ITEM_CLICKED"] = "search/ITEM_CLICKED";
    Actions["SUGGESTION_CLICKED"] = "search/SUGGESTION_CLICKED";
    Actions["SUGGESTION_ADDED"] = "search/SUGGESTION_ADDED";
    Actions["SUGGESTION_REMOVED"] = "search/SUGGESTION_REMOVED";
    Actions["KEYPHRASE_CHANGED"] = "search/KEYPHRASE_CHANGED";
})(Actions || (Actions = {}));
